import React from 'react'
import { useSelector } from 'react-redux'
import LocationProjectPartners from 'screens/locations/contentPages/LocationProjectPartners'
import { useParams } from 'react-router-dom'

const ProjectPartners = () => {
	const { id } = useParams()

	const { projectInitialized, projectLoading, project } = useSelector(state => {
		return {
			projectInitialized: state.projects.isInitialized,
			projectLoading: state.projects.isLoading,
			project: state.projects.entities[id],
		}
	})

	const locationId = project ? project.projectAsset?._id : null

	const { isInitialized, location, loading } = useSelector(state => {
		return {
			isInitialized: state.locations.isInitialized,
			loading: state.locations.isLoading,
			location: state.locations.entities[locationId],
		}
	})

	// TODO: Create skeleton loader
	if (loading || !location) return null
	if (projectLoading || !projectInitialized || !project) return null

	return <LocationProjectPartners partnerType="locations" location={location} project={project} />
}

export default ProjectPartners
